<template>
  <div id="choose-product" class="tw-w-full tw-px-4 md:tw-px-0 md:tw-w-10/12 tw-mt-12 tw-mb-6 tw-flex tw-flex-wrap tw-justify-between tw-pb-5">
    <v-card
        id="motor-insurance"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3"
        flat
    >
      <v-icon color="primary" size="70" alt="car">mdi-account-outline</v-icon>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text  title-font tw-text-base md:tw-text-base tw-px-3 tw-mt-4">Yourself</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">I'm only looking to cover myself at this time</p>
        <StartHealthModal :beneficiary-types="['principal']" :is-edit="isEdit" />
      </div>
    </v-card>
    <v-card
        id="motor-insurance"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3"
        flat
    >
      <v-icon color="primary" size="70" alt="car">mdi-account-multiple-outline</v-icon>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text  title-font tw-text-base md:tw-text-base tw-px-3 tw-mt-4">You and Spouse</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">I'm looking to cover my spouse and I
        </p>
        <StartHealthModal :beneficiary-types="['principal', 'spouse']" :is-edit="isEdit" />
      </div>
    </v-card>
    <v-card
        id="motor-insurance"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3"
        flat
    >
      <div>
        <v-icon color="primary" size="70" alt="car">mdi-account-multiple-outline</v-icon>
        <v-icon color="primary" size="60" alt="car">mdi-account-child-outline</v-icon>
      </div>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text  title-font tw-text-base md:tw-text-base tw-px-3 tw-mt-4">You, Spouse and Children</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">I'm looking to cover my spouse, our children and I
        </p>
        <StartHealthModal :beneficiary-types="['principal', 'spouse', 'child']" :is-edit="isEdit"/>
      </div>
    </v-card>
     <v-card
        id="motor-insurance"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3"
        flat
    >
      <div>
        <v-icon color="primary" size="70" alt="car">mdi-account-outline</v-icon>
        <v-icon color="primary" size="60" alt="car">mdi-account-child-outline</v-icon>
      </div>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text  title-font tw-text-base md:tw-text-base tw-px-3 tw-mt-4">You and Children</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">I'm looking to cover my children and I
        </p>
        <StartHealthModal :beneficiary-types="['principal', 'child']" :is-edit="isEdit"/>
      </div>
    </v-card>
  </div>
</template>

<script>
import StartHealthModal from '@/components/rfq/health/StartHealthModal';

export default {
  name: 'StartHealth',
  props: ['isEdit'],
  components: { StartHealthModal },
};
</script>
